<template>
    <TabLayout
        :title="Lang.get('employeedashboard::pages/settings/account.edit.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/account.edit.subtitle')"
        :tabName="'changePassword'"
    >
        <form @submit.prevent="submit()" class="row">
            <div class="row col-12">
                <div class="form-group col-12 col-xl-6">
                    <label for="currentPassword" class="font-poppins w-100 color-dark-blue">
                        {{ Lang.get('employeedashboard::shared.current_password') }}
                    </label>
                    <input
                        id="currentPassword"
                        v-model="form.current_password"
                        type="password"
                        class="form-control font-poppins"
                        :placeholder="Lang.get('employeedashboard::shared.placeholder.current_password')"
                        autocomplete="current-password">
                    <form-error :error="errors.current_password"></form-error>
                </div>
            </div>

            <div class="form-group mt-4 col-xl-6">
                <label for="employeePassword" class="font-poppins w-100 color-dark-blue">
                    {{ Lang.get('employeedashboard::shared.new_password')}}
                    <a @click="showOrHidePasswordValue('password')">
                            <span class="float-right cursor-pointer link-show">
                                <img
                                    :src="passwordType === 'password' ? '/img/login/icon-show.svg' : '/img/login/icon-hide.svg'">
                                {{
                                    passwordType === 'password'
                                        ? Lang.get('employeedashboard::shared.show')
                                        : Lang.get('employeedashboard::shared.hide')
                                }}
                            </span>
                    </a>
                </label>
                <input
                    v-model="form.password"
                    :type="passwordType"
                    class="form-control font-poppins password-check"
                    id="employeePassword"
                    :error="errors.password"
                    :placeholder="Lang.get('employeedashboard::shared.placeholder.new_password')"
                    autocomplete="new-password">
                <div v-if="errors && Array.isArray(errors.password)" class="form-error">
                    {{ errors.password.join(',') }}
                </div>
                <div v-if="errors && errors.password instanceof String" class="form-error">{{ errors.password }}</div>

            </div>

            <div class="form-group mt-4 col-xl-6">
                <label for="employeePassword2" class="font-poppins w-100 color-dark-blue">
                    {{ Lang.get('employeedashboard::shared.password_confirm') }}

                    <a @click="showOrHidePasswordValue('passwordConfirm')">
                            <span class="float-right cursor-pointer link-show">
                                <img :src="passwordConfirmType === 'password' ? '/img/login/icon-show.svg' : '/img/login/icon-hide.svg'">
                                {{
                                    passwordConfirmType === 'password'
                                        ? Lang.get('employeedashboard::shared.show')
                                        : Lang.get('employeedashboard::shared.hide')
                                }}
                            </span>
                    </a>
                </label>
                <input
                    v-model="form.password_confirmation"
                    :type="passwordConfirmType"
                    class="form-control font-poppins"
                    :class="passwordConfirmEqualsPassword ? 'is-valid' : ''"
                    id="employeePassword2"
                    :error="errors.password_confirmation"
                    :placeholder="Lang.get('employeedashboard::shared.placeholder.password_confirm')"
                    autocomplete="new-password">

                <div v-if="errors && Array.isArray(errors.password_confirmation)" class="form-error">
                    {{ errors.password_confirmation.join(',') }}
                </div>
                <div v-if="errors && errors.password_confirmation instanceof String" class="form-error">
                    {{ errors.password_confirmation }}
                </div>
            </div>
            <password-validation class="col-12 col-md-6 mt-0" :inputVal="form.password"/>

            <div class="col-12">
                <SubmitButton class="mt-3 mb-4">
                    {{ Lang.get('employeedashboard::shared.save.button') }}
                </SubmitButton>
            </div>

        </form>

    </TabLayout>
</template>

<script>
import TabLayout from "@/Pages/Settings/Shared/TabLayout"
import TextInput from "@/Shared/TextInput";
import throttle from "lodash/throttle";
import FlashMessages from "@/Shared/FlashMessages";
import Checkbox from "@/Shared/Checkbox";
import FormError from "@/Shared/FormError";
import SelectInput from "@/Shared/SelectInput";
import SubmitButton from "@/Shared/SubmitButton";
import PasswordValidation from "@/Shared/PasswordValidation.vue";

export default {
    metaInfo: {title: Lang.get('employeedashboard::pages/settings/change-password.title')},
    components: {
        TabLayout,
        FormError,
        Checkbox,
        TextInput,
        FlashMessages,
        SelectInput,
        SubmitButton,
        PasswordValidation
    },
    props: {
        errors: Object,
        isValidated: Object,
    },

    data() {
        return {
            passwordType: 'password',
            passwordConfirmType: 'password',
            passwordConfirmEqualsPassword: false,
            changePassword: false,
            form: this.$inertia.form({
                current_password: null,
                password: null,
                password_confirmation: null,
            }),
        }
    },

    methods: {
        submit() {
            this.form.put(this.route('nl.employeedashboard.settings.account.change-password.attempt'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },

        showOrHidePasswordValue(input) {
            switch (input) {
                case 'password':
                    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
                    break;
                case 'passwordConfirm':
                    this.passwordConfirmType = this.passwordConfirmType === 'password' ? 'text' : 'password';
                    break;
            }
        },
    },
    watch: {
        'form.password': {
            handler: throttle(function () {

                this.passwordConfirmEqualsPassword = this.form.password === this.form.passwordConfirmation;

            }, 150),
            deep: true,
        },
    },
}
</script>
